import dayjs from "dayjs";
import { DateValue } from "@mantine/dates";

export const formatDate = (date: DateValue): string => {
    return dayjs(date).format("DD MMM YYYY");
};

/**
 * Safely converts a DateValue to a Date object, ensuring it's parsed as local time.
 * This prevents timezone-related off-by-one-day issues when parsing date strings.
 * @param {DateValue} dateValue - The date value to convert (can be Date, string, or null)
 * @returns {Date | null} The Date object or null if input is null/undefined
 */
export const toLocalDate = (dateValue: DateValue): Date | null => {
    if (!dateValue) return null;

    // If it's already a Date object, return a copy
    if (dateValue instanceof Date) {
        return new Date(dateValue);
    }

    // If it's a string, parse it explicitly as local time using dayjs
    if (typeof dateValue === "string") {
        return dayjs(dateValue).toDate();
    }

    return null;
};

export const getMinDate = (limitPastDays?: number, limitSelectionMonths?: number): Date | undefined => {
    const now = dayjs();

    const dayLimit = limitPastDays ? now.subtract(limitPastDays, "day") : null;

    const monthLimit = limitSelectionMonths ? now.subtract(limitSelectionMonths, "month") : null;

    if (dayLimit && monthLimit) {
        // Return the *later* of the two (most restrictive)
        return dayLimit.isAfter(monthLimit) ? dayLimit.toDate() : monthLimit.toDate();
    }

    return (dayLimit || monthLimit)?.toDate();
};
